import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";
import {FlightModeSymbol} from "../objects/FlightModeSymbol";

export class ExplodeBombs implements SimplePresentation {

    shouldRun(): boolean {
        return ((FlightMode.model.responseWin == 0 || (FlightMode.model.brokeTheBank &&
                                                   !FlightMode.model.anyWinningSymbols())) &&
                (FlightMode.model.bombPositions()[0].length > 0));
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)})
        })

        const bombPositions = FlightMode.model.bombPositions();
        const bombs = bombPositions[0].slice();

        const bruh = bombPositions.findIndex((index) => index.length == 0);
        const finalBombIndex = bruh > -1 ? bruh : 6
        const multipliers = FlightMode.model.allMultiplierPositions();

        //if (FlightMode.model.responseWin == 0) {
        //    bombPositions[0].push(...FlightMode.model.multiplierSymbolPositions());
        //    bombPositions[0].push(...FlightMode.model.goldenMultiplierPositions());
        //}

        const avalanchedPositions:string[][] = [
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
            ["", "", "", ""],
        ];
        for (let reel = 0; reel < finalBombIndex; reel++) {
            bombPositions[reel].forEach((pos) => {
                const symbol = FlightMode.reelView.getSymbolAt(pos.reel, pos.row);
                if (["MAX", "S", 'W', "XH"].indexOf(symbol.symbolName) == -1) {
                    avalanchedPositions[pos.reel][pos.row] = "AV";
                }
            })
        }
        multipliers.forEach((pos) => avalanchedPositions[pos.reel][pos.row] = "AV");

        tl.add(bombs.map((bomb) =>  {
            return gsap.timeline()
                .add(FlightMode.reelView.moveUpSymbolAt(bomb.reel, bomb.row))
                .add(FlightMode.reelView.getSymbolAt(bomb.reel, bomb.row).startBombFuse())
                .add(FlightMode.reelView.moveDownSymbolAt(bomb.reel, bomb.row))
        }), '>0.15')
        tl.add(() => {
            FlightMode.soundPlayer.playSound("symPop");
        });

        for (let reel = 0; reel < finalBombIndex; reel++) {
            const reelTl = gsap.timeline();
            bombPositions[reel].forEach((pos) => {
                const symbol = FlightMode.reelView.getSymbolAt(pos.reel, pos.row);
                if (["MAX", "S", 'W', "XH"].indexOf(symbol.symbolName) == -1) {
                    reelTl.add(gsap.timeline()
                            .add(FlightMode.reelView.moveUpSymbolAt(pos.reel, pos.row), '<')
                            .add(symbol.explode(-1), '<')
                            .add(FlightMode.reelView.moveDownSymbolAt(pos.reel, pos.row)),
                        '<');
                }
                else if (symbol.symbolName == "MAX") {
                    reelTl.add(gsap.timeline()
                            .add(FlightMode.reelView.moveUpSymbolAt(pos.reel, pos.row), '<')
                            .add(symbol.unlockMaxWin(), '<')
                            .add(FlightMode.reelView.moveDownSymbolAt(pos.reel, pos.row)),
                        '<');
                }
            })
            if (reel == finalBombIndex - 1) {
                FlightMode.model.allMultiplierPositions().forEach((pos) => {
                    const symbol = FlightMode.reelView.getSymbolAt(pos.reel, pos.row);
                    reelTl.add(gsap.timeline()
                            .add(FlightMode.reelView.moveUpSymbolAt(pos.reel, pos.row), '<')
                            .add(symbol.explode(), '<')
                            .add(FlightMode.reelView.moveDownSymbolAt(pos.reel, pos.row)),
                        '<');
                })
            }
            if (reelTl.duration() == 0)
                continue;
            tl.add(reelTl, '<0.05')
        }

        const obamna = avalanchedPositions.map((reel) => reel.map((row) => row == "AV"));
        tl.add(FlightMode.reelView.applyGravity(obamna), '>-0.4');
        tl.add(FlightMode.reelView.updateMultiplierCounter(1), '>');

        tl.add(() => {
            controller.finish();
        }, '>-0.2')
    }
}
